import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TimeProvider } from './TimeContext';
import Homepage from './pages/Homepage';
import Programs from './pages/Programs';
import ProgramDetails from './pages/ProgramDetails';
import Alumni from './pages/Alumni';
import Admin from './pages/Admin';
import Enrollment from './pages/Enrollment';
import CampusLife from './pages/CampusLife';
import Privacy from './pages/Privacy';

import RouteAnalytics from './analytics/RouteAnalytics';
import CookieConsent from './components/CookieConsent';

/*
 * The previous `ReactGA.initialize('G-XXXXXXXXXX')` that sat here has been
 * removed. Three problems with it:
 *
 *   1. `G-XXXXXXXXXX` is Google's documentation placeholder, not a real
 *      measurement ID — analytics has never recorded anything.
 *   2. It ran at module scope, before the app rendered and before any
 *      visitor could consent to being tracked.
 *   3. Nothing ever sent a pageview, so even with a real ID it would have
 *      had the same single-pageview blind spot as the Meta snippet.
 *
 * GA4 now lives in src/analytics/googleAnalytics.js, reads its ID from
 * REACT_APP_GA4_ID, and starts only after consent. If that variable is
 * unset it does nothing — see docs/GOOGLE-ANALYTICS.md.
 */

function App() {
  return (
    <TimeProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {/* Fires a pageview to Meta and GA4 on every navigation.
            Must be inside <Router> — it calls useLocation(). Renders nothing. */}
        <RouteAnalytics />

        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:id" element={<ProgramDetails />} />
          <Route path="/alumni" element={<Alumni />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/enrollment" element={<Enrollment />} />
          <Route path="/campus-life" element={<CampusLife />} />
          {/* The consent banner links here, so this route has to exist. */}
          <Route path="/privacy" element={<Privacy />} />
        </Routes>

        {/* Nothing loads from Meta or Google until a visitor accepts. */}
        <CookieConsent />
      </Router>
    </TimeProvider>
  );
}

export default App;
